import { BaseEditModel } from "model/BaseEditModel";

export default class AprovacaoFaixaValores implements BaseEditModel {

    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    codigo: string | null;
    tipoRotina: string;
    descricao: string;
    ativo: boolean;
    valor: number;
    formula: string;

    constructor(
        id = 0,
        codigo = '',
        tipoRotina = 'VIAGEM',
        descricao = '',
        ativo = true,
        valor = 0,
        formula = '',
    ) {
        this.id = id;
        this.codigo = codigo;
        this.tipoRotina = tipoRotina;
        this.descricao = descricao;
        this.ativo = ativo;
        this.valor = valor;
        this.formula = formula;
    }
}
